import styled from "@emotion/styled";

export const UploaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;

export const UploaderHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const ButtonsBox = styled.div`
  display: flex;
  gap: 12px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: lightgray;
`;

export const ImageBox = styled.div`
  height: 100px;
  margin: 15px auto 0;
  border: 1px solid lightgray;
`;

export const Image = styled.img`
  height: 100%;
  width: auto;
  max-width: 100%;
`;
